import keyMirror from 'key-mirror';

export default keyMirror({
  ASSIGN: null,
  CREATE: null,
  DELETE: null,
  EDIT: null,
  VIEW: null
});
